import { OWebPageBase, tPageRoute } from "oweb";
import PSurveyComponent from "@/components/pages/PSurvey.vue";
import { VueConstructor } from 'vue';

export default class PSurvey extends OWebPageBase<VueConstructor> {
	getName() {
		return "PSurvey"
	}

	getRoutes(): tPageRoute[] {
		return [ {
			title: "",
			slug: "w-survey-menu",
			path: "/surveys/:id",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-about",
			path: "/surveys/:id/about",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-edit",
			path: "/surveys/:id/edit",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-builder",
			path: "/surveys/:id/build",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-runner",
			path: "/surveys/:id/run",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-stats",
			path: "/surveys/:id/stats",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-answers",
			path: "/surveys/:id/answers",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-answers-unsent",
			path: "/surveys/:id/answers/unsent",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "",
			slug: "w-survey-answer-view",
			path: "/surveys/:id/answers/:answer_id",
			pathOptions: {
				id: "num",
				answer_id: "num"
			}
		} ]
	}

	getComponent() {
		return PSurveyComponent;
	}
}
